import { render, staticRenderFns } from "./PrivacyKeusote.vue?vue&type=template&id=db69680a&scoped=true"
import script from "./PrivacyKeusote.vue?vue&type=script&lang=ts"
export * from "./PrivacyKeusote.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyKeusote.vue?vue&type=style&index=0&id=db69680a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db69680a",
  null
  
)

export default component.exports